module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aviwK"))).then(() => parcelRequire('5erN3'));